import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import {
  isDesktopExperimentEnabled,
  isPromoOffersEnabledSelector,
  isMobileExperimentEnabled,
} from '../../selectors/promoOffersSelection';

export const usePromoSelectionEnabled = () => {
  const device = useDeviceType();

  const isPromoOffersEnabled = useSelector(isPromoOffersEnabledSelector);
  const isDesktopEnabled = useSelector(isDesktopExperimentEnabled);
  const isMobileEnabled = useSelector(isMobileExperimentEnabled);

  if (!isPromoOffersEnabled) {
    return false;
  }

  return device === 'desktop' ? isDesktopEnabled : isMobileEnabled;
};
